<template>
  <div>
    <div v-if="bubbleMessages.length == 0" class="primary-color pl-1">{{ $t('No reply') }}</div>
    <div>
      <ul style="margin: 0; padding: 0">
        <li
          v-for="(item, index) in bubbleMessages"
          :key="'intent_item_' + index"
          style="list-style-type: none"
        >
          <template>
            <move-vertical
              :index="index"
              :max="bubbleMessages.length"
              style="
                width: 20px;
                min-width: 20px;
                display: inline-block;
                float: left;
                margin-right: 10px;
              "
              @onMove="onMove(index, $event)"
            >
              <a
                v-if="bubbleMessages && bubbleMessages.length > 0"
                href="javascript:void(0);"
                style="float: left; margin-left: 5px"
                @click="onDelete(index)"
              >
                <i class="fas fa-trash"></i> </a
              >&nbsp;
            </move-vertical>
            <template v-if="item.type == 'text'">
              <template v-if="item.text == '{viewsummary}'">
                <view-cart-summary-viewer></view-cart-summary-viewer>
                <div class="clearfix"></div>
              </template>
              <template v-else>
                <div
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    max-width: 240px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    cursor: pointer;
                  "
                >
                  <div style="font-size: 12px; color: black">
                    <template>
                      <div style="padding: 8px 6px 2px; background-color: #f1f0f0">
                        <div
                          class="form-control"
                          :class="{
                            'has-error': errors.has(
                              'answer_' + (indexAlternative - 1) + '_text_' + index
                            )
                          }"
                        >
                          <autoresize-textarea
                            :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                            v-model.trim="item.text"
                            v-validate
                            maxlength="1024"
                            class
                            :placeholder="$t('Chatbot answers')"
                            name="answer"
                            data-vv-as="Answer"
                            :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                            style="resize: none; display: inherit; margin-bottom: 5px"
                          ></autoresize-textarea>
                          <v-layout>
                            <v-flex class="error--text">
                              {{
                                errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                              }}
                            </v-flex>
                            <v-flex shrink class="text-xs-right caption grey--text">
                              {{ item.text.length }}/1024
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="clearfix"></div>
                </div>

                <!-- <intent-prefill
                  @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
                ></intent-prefill> -->
              </template>
            </template>
            <template v-if="item.type == 'button'">
              <div
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  max-width: 240px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                "
              >
                <div style="font-size: 12px; color: black">
                  <template>
                    <div
                      style="
                        padding: 8px 6px 2px;
                        background-color: #f1f0f0;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                      "
                    >
                      <div
                        class="form-control"
                        :class="{
                          'has-error': errors.has(
                            'answer_' + (indexAlternative - 1) + '_text_' + index
                          )
                        }"
                      >
                        <autoresize-textarea
                          :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                          v-model="item.text"
                          v-validate
                          maxlength="640"
                          class
                          :placeholder="$t('Chatbot answers')"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_' + (indexAlternative - 1) + '_text_' + index"
                          style="resize: none; display: inherit; margin-bottom: 5px"
                        ></autoresize-textarea>

                        <v-layout>
                          <v-flex class="error--text">
                            {{
                              errors.first('answer_' + (indexAlternative - 1) + '_text_' + index)
                            }}
                          </v-flex>
                          <v-flex shrink class="text-xs-right caption grey--text">
                            {{ item.text.length }}/640
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="clearfix"></div>
                <div
                  style="
                    float: left;
                    width: 100%;
                    border: 1px solid #eee;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  "
                >
                  <ul class="message-group message-group-flush" style="margin-bottom: 0px">
                    <template v-if="item.buttons && item.buttons.length > 0">
                      <template v-for="(button, bindex) in item.buttons">
                        <li
                          v-if="button"
                          :key="bindex"
                          class="message-group-item text-xs-center"
                          style="
                            position: relative;
                            border-left: none;
                            border-right: none;
                            border-bottom: none;
                            border-radius: 0px;
                            padding: 5px 10px;
                          "
                          :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                        >
                          <add-generic-button
                            :ref="'buttonGeneric_' + bindex"
                            :key="'group_button_' + bindex + '_' + editTimestamp"
                            v-model="item.buttons[bindex]"
                            :is-edit="true"
                            @onSave="editButton(index, bindex, $event)"
                          >
                            <div
                              slot="body"
                              class="text-xs-center"
                              style="overflow: auto; position: relative; width: 100%"
                            >
                              <div style="color: #0084ff" :title="button.title">
                                {{ button.title | truncate(12) }}
                              </div>
                              <div class="clearfix"></div>

                              <div style="margin: 0; font-size: 10px; color: darkgrey">
                                <div v-if="button.type == 'web_url'" :title="button.url">
                                  {{ button.url | truncate(20) }}
                                </div>
                                <div v-else-if="button.type == 'postback'" :title="button.payload">
                                  {{ button.payload | truncate(20) }}
                                </div>
                                <div
                                  v-else-if="button.type == 'phone_number'"
                                  :title="button.payload"
                                >
                                  {{ button.payload | truncate(20) }}
                                </div>
                                <div v-else>&nbsp;</div>
                              </div>
                            </div>

                            <template slot="append">
                              <v-list-tile
                                :disabled="bindex <= 0"
                                @click="onMoveButton(bindex, 'up', item)"
                              >
                                <v-list-tile-title
                                  :style="bindex <= 0 ? `color: lightgrey` : ''"
                                  class="primary-color"
                                  >{{ $t('Move up') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile
                                :disabled="bindex >= item.buttons.length - 1"
                                @click="onMoveButton(bindex, 'down', item)"
                              >
                                <v-list-tile-title
                                  :style="
                                    bindex >= item.buttons.length - 1 ? `color: lightgrey` : ''
                                  "
                                  class="primary-color"
                                  >{{ $t('Move down') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile @click="deleteButton(index, bindex)">
                                <v-list-tile-title class="primary-color">{{
                                  $t('Delete')
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </add-generic-button>
                        </li>
                      </template>
                    </template>
                    <li
                      v-if="item.buttons && item.buttons.length < 3"
                      class="message-group-item"
                      style="
                        border-left: none;
                        border-right: none;
                        border-bottom: none;
                        border-radius: 0px;
                        text-align: center;
                        padding: 10px 0px;
                      "
                      :style="{
                        'border-top': item.buttons.length != 0 ? '1px solid #eee' : 'none'
                      }"
                    >
                      <add-generic-button
                        :key="'group_new_button_' + saveTimestamp"
                        v-model="newButton"
                        @onSave="addNewButton(index, $event)"
                      >
                        <template slot="body">
                          <span class="fas fa-plus"></span>
                          {{ $t('Add button') }}
                        </template>
                      </add-generic-button>
                    </li>
                  </ul>
                </div>
                <input
                  v-model="item.buttons.length"
                  v-validate="''"
                  type="hidden"
                  :name="'answer_' + (indexAlternative - 1) + '_buttons_' + index"
                  data-vv-as="Buttons"
                />
                <div
                  class="form-control"
                  :class="{
                    'has-error': errors.has(
                      'answer_' + (indexAlternative - 1) + '_buttons_' + index
                    )
                  }"
                >
                  <span
                    v-show="errors.has('answer_' + (indexAlternative - 1) + '_buttons_' + index)"
                    class="text-error"
                  >
                    {{ errors.first('answer_' + (indexAlternative - 1) + '_buttons_' + index) }}
                  </span>
                </div>
              </div>
              <intent-prefill
                @addIntentPrefill="addIntentPrefill(indexAlternative - 1, index, $event)"
              ></intent-prefill>
            </template>
            <template v-else-if="item.type == 'image'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <uploadfile
                  ref="answer"
                  v-model="item.image_url"
                  v-validate
                  :height="181"
                  data-vv-as="Image"
                  :data-vv-name="'answer_' + (indexAlternative - 1) + '_image_' + index"
                ></uploadfile>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="item.type == 'video'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  min-height: 150px;
                  border: 1px solid #eee;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                "
              >
                <template v-if="item.picture">
                  <v-img :src="item.picture" :aspect-ratio="16 / 9" color="grey"></v-img>
                </template>
                <template v-else>
                  <v-responsive :aspect-ratio="16 / 9">
                    <div style="background: #eee; height: 100%"></div>
                  </v-responsive>
                </template>

                <v-layout
                  fill-height
                  absolute
                  class="text-xs-center"
                  style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                >
                  <div style="margin: auto; width: 100%" :title="item.source" :alt="item.source">
                    <v-btn fab small depressed color="white">
                      <v-icon large>play_circle_filled</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </div>
              <div class="clearfix"></div>
            </template>
            <template v-else-if="item.type == 'generic'">
              <intent-generic-manage
                v-model="item.data"
                :channel="channel"
                :ratio="item.ratio"
                @changeRatio="changeRatio(index, $event)"
                @deleteMessage="onDelete(index)"
              ></intent-generic-manage>
            </template>

            <template v-else-if="item.type == 'ntn_template'">
              <intent-ntn-manage
                v-model="bubbleMessages[index]"
                :ratio="item.ratio"
                @changealtText="changealtText(index, $event)"
                @changeRatio="changeRatio(index, $event)"
                @deleteMessage="onDelete(index)"
              ></intent-ntn-manage>
            </template>

            <template v-else-if="item.type == 'payment'">
              <div
                style="
                  padding: 1em;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 240px;
                  min-height: 100px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  background-color: #eeeeee;
                "
              >
                <v-layout style="margin-bottom: 0px; word-break: break-all" row>
                  <vue-simple-svg
                    :filepath="'/static/img/assets/get_started/payment.svg'"
                    width="40px"
                    height="40px"
                    class="img"
                    style="
                      border-right: 2px solid #c5c5c5;
                      padding-right: 10px;
                      padding-top: 1em;
                      padding-bottom: 1em;
                      vertical-align: middle;
                    "
                  />
                  <v-flex style="padding-left: 1em">
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Detail') }}:</strong>
                      <br />
                      {{ item.data.detail }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Amount') }}:</strong>
                      <br />
                      {{ item.data.amount }}
                    </div>
                    <div style="margin-bottom: 10px">
                      <strong>{{ $t('Delivery Method') }}:</strong>
                      <br />
                      {{ item.data.delivery.name }}
                    </div>
                    <div style="margin-bottom: 10px; white-space: break-spaces">
                      <strong>{{ $t('Response Message') }}:</strong>
                      <br />
                      {{ item.data.response }}
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small"
                  @click="paymentForm(item, index)"
                >
                  <i class="fa fa-pencil-alt middle"></i>
                </v-btn>
              </div>
              <!-- <intent-generic-manage v-model="item.data" @deleteMessage="onDelete(index)"></intent-generic-manage> -->
            </template>

            <template
              v-else-if="['removeandaddtocart', 'addtocart', 'removetocart'].includes(item.type)"
            >
              <span>
                <view-cart-summary-viewer2 :items="item.data"></view-cart-summary-viewer2>
              </span>
              <span style="inline-block">
                <div>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        fab
                        outline
                        color="primary"
                        class="extra-small"
                        v-on="on"
                        @click="editRemoveAndAdd(item, index)"
                      >
                        <i class="fa fa-pencil-alt middle"></i>
                      </v-btn>
                    </template>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>
                </div>
              </span>
            </template>

            <template v-else-if="item.type == 'welcome_message'">
              <message-viewer v-model="welcomeMessage.messages"></message-viewer>
              <!-- <intent-getstarted v-if="welcomeMessage" v-model="welcomeMessage"></intent-getstarted> -->
            </template>
            <template v-else-if="item.type == 'flex'">
              <intent-line-flex
                v-model="item.contents"
                :item="item"
                @deleteMessage="onDelete(index)"
              ></intent-line-flex>
            </template>
            <template v-else-if="['imagemap', 'basicimagemap'].includes(item.type)">
              <intent-line-image-map
                v-model="bubbleMessages[index]"
                @deleteMessage="onDelete(index)"
              ></intent-line-image-map>
            </template>
            <template v-else-if="item.type == 'sticker'">
              <div
                :ref="'answer_' + (indexAlternative - 1) + '_' + index"
                class="message"
                style="
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  width: 181px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  border: 1px solid #eee;
                  width: 100%;
                  max-width: 180px;
                "
              >
                <v-img
                  aspect-ratio="1"
                  :src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  :lazy-src="`/static/img/assets/stickers/${item.packageid}/${item.stickerid}.png`"
                  style="width: 100%"
                >
                  <template #placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                <div
                  style="background: #4bd64b; padding: 10px; line-height: 20px"
                  small
                  disabled
                  class="white--text"
                >
                  {{ $t('This item will be shown only on Line Chatbot') }}
                </div>
              </div>
            </template>
            <div class="clearfix"></div>
            <div class="form-control has-error" style="margin-left: 30px">
              <span
                v-show="errors.has('answer_' + (indexAlternative - 1) + '_image_' + index)"
                class="text-error"
                >{{ errors.first('answer_' + (indexAlternative - 1) + '_image_' + index) }}</span
              >
            </div>
            <div style="margin-bottom: 10px"></div>
          </template>
        </li>
      </ul>
    </div>

    <v-layout class="mb-3" :class="{ 'red--text': bubbleCount >= addLimit }">
      <v-flex class="text-xs-right caption">{{ bubbleCount }} / {{ addLimit }}</v-flex>
    </v-layout>

    <div v-if="bubbleCount > 5" class="mt-2 caption warning--text">
      <v-icon small color="warning">warning</v-icon>
      {{ $t('Warning: only 5 items will be shown on Line Chatbot') }}
    </div>

    <div style="overflow-x: auto; margin-top: 15px" class="pl-3">
      <label for class="caption">{{ $t('Add more item') }}</label>
      <ul class="customize-message-tool">
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent || inactiveTextBubble }"
          :disabled="inactiveTextBubble"
          @click="inactiveTextBubble ? false : addIntentItem('text')"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Message') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
          @click="addIntentItem('button')"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-button.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Button') }}
        </li>
        <li
          v-ripple
          v-tooltip.top="{ content: hasAloneIntentTooltips, visible: hasAloneIntent }"
          :class="{ inactive: bubbleCount >= addLimit || hasAloneIntent }"
          @click="addIntentItem('image')"
        >
          <vue-simple-svg
            :filepath="'/static/img/assets/get_started/add-image.svg'"
            width="40px"
            height="40px"
            class="img"
          />
          {{ $t('Image') }}
        </li>
      </ul>
    </div>

    <input
      v-validate="'max_value:' + addLimit"
      type="hidden"
      name="bubbleLimit"
      :data-vv-as="$t('Chatbot answers') + ' ' + indexAlternative"
      :value="bubbleCount"
    />

    <v-dialog v-model="showLineFlex" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <div class="primary--text headline pa-2">Line Flex Message</div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddFlexMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="flexMessage">
          <intent-line-flex-message v-model="flexMessage.contents"></intent-line-flex-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('Cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IntentGroupItem from '../../intent/IntentGroupItem.js'

export default {
  mixins: [IntentGroupItem]
}
</script>

<style lang="scss">
.customize-message-tool .disabled {
  color: #d4d4d4 !important;
  background-color: #efefef !important;
}
.customize-message-tool .disabled .img {
  fill: #d4d4d4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/TemplateIntentGroupItem.vue